module.exports = "/_next/static/images/error-6147371d9081c84c7aa3f0bee62e9c25.svg";